import {
  apiClient,
  getStoredAuth,
  resolveApiErrorMessage,
} from './authApi';

function withAuthHeaders() {
  const { accessToken } = getStoredAuth();

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

export const commissionApi = {
  async listCommissions(options = {}) {
    const { bustCache = false } = options;

    const response = await apiClient.get('/commissions', {
      headers: {
        ...withAuthHeaders(),
        'Cache-Control': 'no-cache, no-store, max-age=0',
        Pragma: 'no-cache',
        Expires: '0',
      },
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async uploadProofOfPayment(file) {
    const formData = new FormData();
    formData.append('file', file);

    const { accessToken } = getStoredAuth();
    const response = await apiClient.post('/commissions/proof-of-payment/upload', formData, {
      headers: {
        Accept: 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    });

    return response.data;
  },

  async tagCommissionPaid(payload) {
    const response = await apiClient.post('/commissions/tag-paid', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async releaseCommissions(payload) {
    const response = await apiClient.post('/commissions/release', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async cancelCommission(payload) {
    const response = await apiClient.post('/commissions/cancel', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },
};

export function resolveCommissionApiError(error) {
  return resolveApiErrorMessage(error, 'Failed to process commissions request.');
}
